import { Gift } from "lucide-react";
import { Section, Kicker, Reveal } from "./primitives";

const BONUSES = [
  { n: "BONO 1", t: "Pack de informes técnicos blindados", d: "Las plantillas corporativas oficiales listas para rellenar que se entregan a directores médicos tras cada servicio. Transmite una imagen de empresa de primer nivel y justifica tarifas altas.", v: "$150 USD" },
  { n: "BONO 2", t: "Masterclass — Control de calidad y configuración", d: "Aprende a interpretar las reglas de Westgard, entender qué busca el bacteriólogo y cómo configurar los controles dentro del analizador para dejarlo 100% operativo.", v: "$200 USD" },
  { n: "BONO 3", t: "Canal exclusivo de alumnos y soporte de campo", d: "Comunidad cerrada para compartir casos reales, resolver dudas de servicio y contar con respaldo técnico para que nunca más te sientas solo frente a un cliente.", v: "$300 USD" },
];

export const Bonos = () => (
  <Section id="bonos">
    <Reveal>
      <Kicker num="05" label="Regalos exclusivos para esta generación" />
      <h2 className="max-w-3xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
        3 bonos de acción rápida diseñados para acelerar tu monetización
      </h2>
    </Reveal>

    <div className="mt-12 grid gap-5 lg:grid-cols-3">
      {BONUSES.map((b, i) => (
        <Reveal key={b.n} delay={i * 0.09} className="h-full">
          <div
            data-testid={`bonus-card-${i + 1}`}
            className="flex h-full flex-col justify-between rounded-2xl border border-amber-400/20 bg-gradient-to-b from-[#131C2E] to-[#0B1322] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-amber-400/50 hover:shadow-[0_18px_50px_rgba(245,158,11,0.12)]"
          >
            <div>
              <span className="inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-amber-400/10 px-3 py-1 font-tech text-[10px] tracking-[0.3em] text-amber-300">
                <Gift className="h-3 w-3" />
                {b.n}
              </span>
              <h3 className="mt-5 font-display text-lg font-semibold text-slate-50 sm:text-xl">{b.t}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{b.d}</p>
            </div>
            <div className="mt-7 border-t border-dashed border-white/10 pt-5">
              <div className="font-display text-2xl font-extrabold text-amber-300">{b.v}</div>
              <div className="mt-1 font-tech text-[10px] tracking-[0.3em] text-slate-500">VALOR REAL</div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);
